require("@fancyapps/fancybox");